<template>
  <div id="products" class="wishlist animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="py4 px3" v-else>
        <div class="py3">
          <div class="p0">
            <h4 class="darkblue bold"><!--Din Ønskeliste--></h4>

            <div id="productFilter">
              <div class="pb2"></div>
              <div class="fit">
                <div class="right-align" v-if="prodMsg == ''">
                  <el-pagination
                    small
                    layout="prev, pager, next"
                    :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                  </el-pagination>
                </div>
                <div class="clearfix" v-if="insideLoading">
                  <div class="col-12">
                    <div class="loader"></div>
                  </div>
                </div>
                <div class="flex flex-wrap" v-else>
                  <div class="lg-col-4 md-col-6 p0" v-for="(prod,index1) in prodData" :key="index1">
                     <div class="clearfix" v-if="prod.LOAD">
                            <div class="col-12">
                              <div class="loader"></div>
                              <p class="mediumgrey bold">Genererer forhåndsvisning...</p>
                            </div>
                          </div>
                          <div v-else></div>
                    <div class="p2">
                      <div class="relative border muted-border more-muted-background">
                        <a class="absolute pointer z2 right-0 mt1 mr1 wishlist-icon" title="Fjern" @click="removeProdWishList(prod.ID)">
                          <span class="mintgreen">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                          </span>
                        </a>
                        <a :href="'#/webshop/product?id=' + prod.ID" class="cart-icon">
                          <div v-if="prod.get_product_image.length">
                            <img :data-key="index1" :src="typeof 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/productPng.php?id='+haaId" width="100%" class="prod-img" rel="preload"  @load="onImageLoad(index1)" @error="checkimage()" v-if="prod.PRODUCT_GROUP == '1000' || prod.PRODUCT_GROUP == '1300' || prod.PRODUCT_GROUP == '1400' || prod.PRODUCT_GROUP == '2000' || prod.PRODUCT_GROUP == '2100' || prod.PRODUCT_GROUP == '2200' || prod.PRODUCT_GROUP == '2300' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '2500' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '10001' || prod.PRODUCT_GROUP == '10002' || prod.PRODUCT_GROUP == '10003' || prod.PRODUCT_GROUP == '10004' || prod.PRODUCT_GROUP == '10005'">
                              <img :src="'https://newcrm.kundematch.dk'+prod.get_product_image[0].showURL" width="100%" rel="preload" class="prod-img" @load="onImageLoad(index1)" v-else>
                          </div>
                          <div v-else>
                            <img :data-key="1" :src="prod.IMAGE_URL" width="100%" rel="preload" class="prod-img" v-if="prod.PRODUCT_GROUP == '9001'">
                          </div>
                        </a>
                      </div>
                      <div class="center">
                        <div class="pb2"></div>
                        <a :href="'#/webshop/product?id=' + prod.ID" class="cart-icon"><span class="h5 darkblue bold block">{{prod.NAME}}</span></a>
                        <span class="h6 mintgreen bold">{{prod.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}} kr</span>
                      </div>
                    </div>
                  </div>
                  <div class="mt3"><span class="bold">{{prodMsg}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WebshopFooter v-if="!loading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter
  },
  data () {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      totalProdCount: 0,
      prodData: [],
      prodMsg: 'Ingen Varer På Din Ønskeliste',
      curPage: 1,
      lastPage: 20,
      form: {
      }
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayWishList()
  },
  methods: {
    checkimage (key) {
      var imgLink = 'http://widget.haandvaerker.dk/products/' + this.prodData[key].PRODUCT_GROUP + '/' + this.prodData[key].EXT + '/productPng.php?id=' + this.haaId
      // console.log(imgLink)
      var img = document.querySelector('img[data-key="' + key + '"]')
      img.src = imgLink
      this.prodData[key].LOAD = true
    },
    onImageLoad (key) {
      //  console.log(this.prodData[key].LOAD)
      this.prodData[key].LOAD = true
      //  console.log('------------')
      //  console.log(this.prodData[key].LOAD)
      //  console.log('------------')
    },
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    displayWishList () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWishList/' + this.haaId + '?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data.data
            var pagLastPage = response.data.data.last_page + '0'
            var products = []
            for (var k = 0; k < dataRes.length; k++) {
              if (dataRes[k].ID != null) {
                products.push(dataRes[k])
              }
            }
            this.prodData = products
            this.lastPage = pagLastPage
            if (!this.prodData.length) {
              this.prodMsg = 'Ingen Varer På Din Ønskeliste.'
            } else {
              this.prodMsg = ''
            }
            this.showBreadCrumb()
            this.loading = false
            this.insideLoading = false
            for (var i = 0; i < this.prodData.length; i++) {
              if (this.prodData[i].SIZE === '' || this.prodData[i].SIZE === null) {
                this.prodData[i].EXT = '0'
              } else {
                this.prodData[i].EXT = this.prodData[i].SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '')
              }
              this.prodData[i].LOAD = false
            }
          } else {
            this.showBreadCrumb()
            this.loading = false
            this.insideLoading = false
            console.log('Error in displayWishList()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    removeProdWishList (id) {
      const compId = this.haaId
      const prodId = id
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddRemoveWishlist',
        parameters: JSON.stringify({
          CompanyID: compId,
          ProductID: prodId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.displayWishList()
            this.calulateWishListCount()
            this.$toastr('success', 'Fjernet')
          } else {
            this.loading = false
            this.insideLoading = false
            console.log('Error in removeProdWishList()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      this.insideLoading = true
    },
    calulateWishListCount () {
      setTimeout(() => {
        const prodWishList = document.querySelectorAll('a.wishlist-icon')
        for (var i = 0; i < prodWishList.length; i++) {
        }
        document.querySelector('.totalWishList').innerText = i
      }, 1000)
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      this.displayWishList()
      this.insideLoading = true
    }
  }
}
</script>
<style>
  .wishlist #productFilter .prod-img {
    /*height: 500px;*/
    height: auto;
    object-fit: cover;
    object-position: top;
  }
  @media (max-width: 64em) {
    .wishlist #productFilter .prod-img {
      height: auto;
      object-fit: contain;
    }
  }
  @media (max-width: 52em) {
    .wishlist #productFilter .el-tabs--left .el-tabs__header.is-left {
      width: 100%;
      margin-right: 0;
      margin-bottom: 3rem;
    }
    .wishlist .el-tabs__content {
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// wishlist.vue?5ee7b589